import {
  Button,
  Card,
  CardHeader,
  IconButton,
  TextField,
} from "@material-ui/core";
import { DeleteOutline, EditOutlined } from "@material-ui/icons";
import { getDatabase, ref, remove, update } from "firebase/database";
import React, { useState } from "react";
import { BeatLoader } from "react-spinners";

const SingleWithdraw = ({ withdraw }) => {
  const [type, setType] = useState(withdraw?.type);
  const [amount, setAmount] = useState(withdraw?.amount);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  function submitSetting() {
    const db = getDatabase();
    setLoading(true);
    update(ref(db, `WithdrawSetting/${withdraw?.withdrawId}`), {
      type,
      amount,
    })
      .then((res) => {
        setLoading(false);
        setShow(false);
      })
      .catch((err) => {
        setLoading(false);
        setError("Something Wrong!!");
      });
  }
  function deleteSetting() {
    const db = getDatabase();
    setLoading(true);
    remove(ref(db, `WithdrawSetting/${withdraw?.withdrawId}`))
      .then((res) => {
        setLoading(false);
        setShow(false);
      })
      .catch((err) => {
        setLoading(false);
        setError("Something Wrong!!");
      });
  }

  return (
    <Card elevation={1}>
      <CardHeader
        //   avatar={<Person aria-label="recipe">R</Person>}
        action={
          <IconButton onClick={() => setShow(!show)} aria-label="settings">
            <EditOutlined />
          </IconButton>
        }
        title={withdraw?.type}
        subheader={withdraw?.amount}
      />
      {show && (
        <div style={{ marginLeft: "25px" }}>
          <TextField
            value={type}
            onChange={(e) => setType(e.target.value)}
            label="Withdraw Type"
            variant="outlined"
            color="secondary"
            required
            type="text"
          />
          <br />
          <br />
          <TextField
            value={amount}
            onChange={(e) => setAmount(parseFloat(e.target.value))}
            label="Amount"
            variant="outlined"
            color="secondary"
            required
            type="number"
          />
          <br />
          <br />
          <p style={{ color: "red" }}>{error}</p>
          {loading ? (
            <BeatLoader loading={loading} />
          ) : (
            <Button
              onClick={() => submitSetting()}
              style={{ marginBottom: "10px" }}
              color="secondary"
              variant="outlined"
              type="submit"
              endIcon={<EditOutlined />}
            >
              Update
            </Button>
          )}
          {loading ? (
            <BeatLoader loading={loading} />
          ) : (
            <Button
              onClick={() => deleteSetting()}
              style={{ marginBottom: "10px" }}
              color="secondary"
              variant="outlined"
              type="submit"
              endIcon={<DeleteOutline />}
            >
              Delete
            </Button>
          )}
        </div>
      )}
    </Card>
  );
};

export default SingleWithdraw;
